import { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './UserDropdown.css';

// Cute emoji icons for avatar
const CUTE_ICONS = [
  '🐱', '🐶', '🐰', '🦊', '🐼', '🐨', '🦁', '🐯',
  '🐸', '🐧', '🐦', '🦉', '🦋', '🐝', '🐙', '🦑',
  '🐢', '🦎', '🦔', '🐿️', '🐳', '🐬', '🦭', '🦦',
];

export default function UserDropdown() {
  const { user, signOut } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Get cute icon based on user ID (consistent for same user)
  const getCuteIcon = () => {
    if (!user?.id) return '🐱';
    // Simple hash from user ID to pick an icon
    const hash = user.id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return CUTE_ICONS[hash % CUTE_ICONS.length];
  };

  // Get short user ID
  const getShortUserId = () => {
    if (!user?.id) return '';
    return user.id.substring(0, 8);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  if (!user) return null;

  return (
    <div className="user-dropdown" ref={dropdownRef}>
      <button
        className="user-dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="user-avatar">{getCuteIcon()}</span>
      </button>

      {isOpen && (
        <div className="user-dropdown-menu">
          <div className="user-dropdown-header">
            <span className="user-dropdown-email">{user.email}</span>
            <span className="user-dropdown-id">ID: {getShortUserId()}</span>
          </div>
          <div className="user-dropdown-divider" />
          <button className="user-dropdown-item" onClick={signOut}>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}
